import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { DropdownBase, InputControl, TextField } from '@/components';
import { NmibleObjectField } from './NmibleObjectField';
const INPUT_CONFIG_MAP = {
    numeric: { inputMode: 'numeric', type: 'number', autoComplete: 'off' },
    email: { inputMode: 'email', type: 'email', autoComplete: 'email' },
    phone: { inputMode: 'tel', type: 'tel', autoComplete: 'tel' },
    zip: { inputMode: 'numeric', type: 'text', autoComplete: 'postal-code' },
    line_1: { inputMode: 'text', type: 'text', autoComplete: 'address-line1' },
    city: { inputMode: 'text', type: 'text', autoComplete: 'address-level2' },
    'year-month': { inputMode: 'numeric', type: 'text', autoComplete: 'off' }
};
const isFullWidth = (maxLength) => !maxLength || maxLength > 40;
const getInputConfig = (clientType) => {
    var _a;
    return (_a = INPUT_CONFIG_MAP[clientType]) !== null && _a !== void 0 ? _a : { inputMode: 'text', type: 'text' };
};
export const NmibleFieldRenderer = ({ field, value, isRequired, onChange, errors }) => {
    var _a, _b;
    const { property_name, title, description, type, client_type, enum: options, pattern } = field;
    const errorMessage = errors === null || errors === void 0 ? void 0 : errors[property_name];
    const fieldWidth = isFullWidth(field.maxLength) ? '100%' : ['100%', '100%', 'calc(50% - 12px)'];
    const patternRegex = useMemo(() => (pattern ? new RegExp(pattern) : null), [pattern]);
    const clientInvalid = useMemo(() => {
        if (!value)
            return false;
        const str = String(value);
        if (patternRegex && !patternRegex.test(str))
            return true;
        if (field.minLength != null && str.length < field.minLength)
            return true;
        if (field.maxLength != null && str.length > field.maxLength)
            return true;
        return false;
    }, [patternRegex, value, field.minLength, field.maxLength]);
    const isInvalid = Boolean(errorMessage) || clientInvalid;
    const handleChange = useCallback((val) => onChange(property_name, val), [onChange, property_name]);
    if (type === 'object' && field.properties) {
        return (_jsx(NmibleObjectField, { w: fieldWidth, title: title, properties: field.properties, requiredFields: field.required_fields, values: (_a = value) !== null && _a !== void 0 ? _a : {}, onChange: handleChange, errors: errors }));
    }
    if (options && Array.isArray(options)) {
        const dropdownValue = (_b = options.find((opt) => opt.key === value)) !== null && _b !== void 0 ? _b : null;
        return (_jsx(InputControl, Object.assign({ error: errorMessage, isInvalid: isInvalid, isRequired: isRequired, label: title, w: fieldWidth }, { children: _jsx(DropdownBase, { isSearchable: true, placeholder: title, "aria-label": title, required: isRequired, value: dropdownValue, options: options, onChange: (opt) => handleChange(opt === null || opt === void 0 ? void 0 : opt.key), getOptionLabel: (opt) => opt.value, getOptionValue: (opt) => opt.key }) })));
    }
    return (_jsx(InputControl, Object.assign({ error: errorMessage, isInvalid: isInvalid, isRequired: isRequired, label: title, w: fieldWidth }, { children: _jsx(TextField, Object.assign({ placeholder: title, "aria-label": title, value: String(value !== null && value !== void 0 ? value : ''), helper: description, pattern: pattern, maxLength: field.maxLength, minLength: field.minLength, name: property_name, onChange: (e) => handleChange(e.target.value), spellCheck: 'false', autoCorrect: 'off' }, getInputConfig(client_type))) })));
};
